import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ViewWrapper from 'views/ViewWrapper';

import ArtistsTable from './artists-table';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
});

function Artists({ classes }) {
  return (
    <ViewWrapper>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Typography className={classes.title} variant="h5">
            Artists
          </Typography>
          <ArtistsTable />
        </Paper>
      </Grid>
    </ViewWrapper>
  );
}

Artists.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Artists);
